module.exports = __webpack_public_path__ + "static/media/check.3a4a76bc.svg";